import { TableLeads } from "./Components/table/TableLeads";

export const PageLeads = () => {
  return <TableLeads />;
};
